module.exports = __webpack_public_path__ + "static/media/gsb-iconLimited-Edition.7c29c801.svg";